import { coreAddTagsSyncSlice } from './add';
import { coreTagsGetAsyncSlice } from './get';
import { coreTagsPostAsyncSlice } from './post';
import { coreTagsRemoveSyncSlice } from './remove';

export const addTag = coreAddTagsSyncSlice.syncActionCreator;
export const removeTag = coreTagsRemoveSyncSlice.syncActionCreator;
export const { requestGetCoreTags, resetGetCoreTags } = coreTagsGetAsyncSlice.asyncActionCreators;
export const { requestPostCoreTags, resetPostCoreTags } = coreTagsPostAsyncSlice.asyncActionCreators;

export * from './_id/actions';
export * from './link/actions';
export * from './unlink/actions';
